import React, { useState, useEffect, useRef, useCallback } from "react";
import "./ArchetypeDetailPage.css";
import rt from "../../images/rt.svg";
import SideArche from "../SideArche/SideArche";
import lock from "../../images/lock1.svg";
import lock1 from "../../images/bul.png";
import an from "../../images/ann.png";
import asm from "../../images/ann.png";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config.js";
import { useParams } from "react-router-dom";
import girl from "../../images/arch1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SideResult from "../SideArche/SideResult";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import SkeletonArchetypeDetail from "../ArchetypeDetailPage/SkeletonArchetypeDetail.jsx";
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import gg from "../../images/pp-logo.gif";
import Subscriptions from '../Subscriptions/Subscriptions';
import { Helmet } from "react-helmet";

function ArchetypeDetailPage({ onLoginChange, free_test_slug ,userdetail,token ,onsignup}) {
  // Section refs

  const LoginShow = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onLoginChange(true);
  };

  const SignShow = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onsignup(true);
  };

  const LoginShowSub = (subids) => {

      if (subids) {
        try {
          let parsedSubIds;

          if (typeof subids === "string") {
            try {
              parsedSubIds = JSON.parse(subids);
            } catch {
              parsedSubIds = [subids];
            }
          } else if (Array.isArray(subids)) {
            parsedSubIds = subids;
          } else {
            parsedSubIds = [subids];
          }

          localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
        } catch (error) {
          console.error("Failed to save subids to localStorage:", error);
        }
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      onLoginChange(true);
  };


  const [isLoading, setIsLoading] = useState(true);
  const [clusterData, setClusterData] = useState([]);
  const [dimensionData, setDimensionData] = useState([]);

  const containerRef = useRef(null);
  const [hasImage, setHasImage] = useState(false);

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [TestLink,setTestLink] = useState(null);

  const [SideBarContent,setSideBarContent] = useState([]);

  const [seo, setSeo] = useState({});

  useEffect(() => {
    const container = containerRef.current;
    if (container && container.querySelector('img')) {
      setHasImage(true);
    }
  }, [dimensionData?.arche_side_bar_content]);
  
  const { slug } = useParams();

  useEffect(() => {
    setIsLoading(true);

    const fetchTest = async () => {
      try {

       const response = await axios.get(`${END_URL}/classification-detail`, {
          params: { slug },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setClusterData(response?.data?.cluster);
        setDimensionData(response?.data?.dimension);

        setTestLink(response?.data?.arche_adver_image_1_link?.slug);

        setSideBarContent(response?.data?.side_bar_content);

        setSeo(response?.data?.seo_page);

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching cluster:", error);
      }
    };

    if (slug) {
      fetchTest();
    }
  }, [slug]);

  const sideResultRef = useRef(null);

  const observerRef = useRef(null);

  const isManualScrollRef = useRef(false);

  const contentRefs = useRef([]);

  const [resultDetails, setResultDetails] = useState([]);

  const [resultReady, setResultReady] = useState([]);

    const handleSub = async (subJson) => {

        try {

            setShowModal(true);

            let subIds = subJson;

            if (typeof subJson === "string") {
            try {
                subIds = JSON.parse(subJson);
            } catch (e) {
                console.error("Invalid JSON string for subIds:", e);
                return;
            }
            }

            if (!Array.isArray(subIds) || subIds.length === 0) {
            console.warn("No valid subscription IDs found:", subIds);
            return;
            }

            const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            setSubscription(res.data);

        } catch (err) {

            console.error("Error loading subscriptions:", err);
        }
    };

  const handleNavigete = (link) => {
      
    if (link) {
      window.location.href = `/${link}`;
    }
  };

  const menuItems = [
    "Core Description",
    "Key Traits",
    "Strong and Weak Angles",
    "Career Advancement",
    "Relationship Building",
  ];

  useEffect(() => {
    const formattedItems = menuItems.map((item, index) => ({
      id: index,
      title: item,
    }));

    setResultDetails(formattedItems);
  }, []);

  useEffect(() => {
    // Cleanup existing observer
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (!resultDetails?.length) return;

    contentRefs.current = [];

    const setupObserver = () => {
      try {
        const elementsToObserve = document.querySelectorAll(".arche-full");

        const observer = new IntersectionObserver(
          (entries) => {
            if (isManualScrollRef.current) return;

            let visibleEntry = null;
            let maxRatio = 0;

            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
                maxRatio = entry.intersectionRatio;
                visibleEntry = entry;
              }
            });

            if (visibleEntry) {
              try {
                const index = parseInt(visibleEntry.target.dataset.index, 10);
                if (!isNaN(index) && index >= 0) {
                  setTimeout(() => {
                    if (
                      sideResultRef.current?.setActiveIndex &&
                      !isManualScrollRef.current
                    ) {
                      sideResultRef.current.setActiveIndex(index);
                    }
                  }, 50);
                }
              } catch (error) {
                console.warn("Error processing intersection entry:", error);
              }
            }
          },
          {
            root: null,
            rootMargin: "-20% 0px -60% 0px",
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0],
          }
        );

        elementsToObserve.forEach((el, idx) => {
          if (el && el.nodeType === Node.ELEMENT_NODE) {
            el.setAttribute("data-index", idx.toString());
            observer.observe(el);
            contentRefs.current[idx] = el;
          }
        });

        observerRef.current = observer;
      } catch (error) {
        console.error("Error setting up intersection observer:", error);
      }
    };

    const timeoutId = setTimeout(setupObserver, 100);

    return () => {
      clearTimeout(timeoutId);
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [resultDetails]);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const handleFocus = useCallback((index) => {
    isManualScrollRef.current = true;

    const targetElement = contentRefs.current[index];
    if (targetElement) {
      try {
        // Calculate position with 120px offset from top
        const elementTop =
          targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementTop - 120; // 120px below from head

        // Use window.scrollTo for precise control
        window.scrollTo({
          top: Math.max(0, offsetPosition), // Ensure we don't scroll above page top
          behavior: "smooth",
        });
      } catch (error) {
        console.warn("Scroll with offset failed, using fallback:", error);
        // Fallback scroll method
        try {
          const elementTop =
            targetElement.getBoundingClientRect().top +
            (window.pageYOffset || document.documentElement.scrollTop);
          const offsetPosition = elementTop - 120;

          if (window.scrollTo) {
            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: "smooth",
            });
          } else {
            // Very old browser fallback
            document.documentElement.scrollTop = Math.max(0, offsetPosition);
          }
        } catch (fallbackError) {
          console.error("All scroll methods failed:", fallbackError);
        }
      }
    }

    setTimeout(() => {
      isManualScrollRef.current = false;
    }, 1500);
  }, []);

  const sideclass = "side-bar-dark";

  const [scollClass, setscollClass] = useState("");

  const handleAdClick = (link) => {
    if (link) {
      window.location.href = `/${link}`;
    }
  };

  // small screen side bar script.........

  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef1 = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleFocus1 = () => {
    setIsOpen(false); // close when list item is clicked
    
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef1.current &&
        !sidebarRef1.current.contains(event.target) &&
        !event.target.closest(".menu-toggleBar")
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



if (isLoading) {
  return (
    <div
     
      className="loadingDiv"
    >
      <img
        src={gg} 
        alt="Loading..."

      />
    </div>
  );
}


console.log(SideBarContent,'SideBarContent');

  return (
    <>

       <Helmet>
        <title>
          {seo?.meta_title ||
            "PersonalityTest - Discover Your True Archetype | Personality Peek"}
        </title>

        <meta
          name="description"
          content={
            seo?.meta_description ||
            "Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
          }
        />

        <meta
          name="keywords"
          content={
            seo?.meta_keywords ||
            "personality assessment test , personality test"
          }
        />

        {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
        {seo?.og_description && (
          <meta property="og:description" content={seo.og_description} />
        )}
        {seo?.og_image && (
          <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
        )}
        {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
        {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

        {seo?.twitter_title && (
          <meta name="twitter:title" content={seo.twitter_title} />
        )}
        {seo?.twitter_description && (
          <meta name="twitter:description" content={seo.twitter_description} />
        )}
        {seo?.twitter_image && (
          <meta
            name="twitter:image"
            content={`${IMG_URL}/d0/${seo.twitter_image}`}
          />
        )}
        {seo?.twitter_card && (
          <meta name="twitter:card" content={seo.twitter_card} />
        )}

        {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

        {!seo?.og_title && (
          <meta
            property="og:title"
            content="PersonalityTest - Discover Your True Archetype | Personality Peek"
          />
        )}
        {!seo?.og_description && (
          <meta
            property="og:description"
            content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
          />
        )}
        {!seo?.og_type && <meta property="og:type" content="website" />}
        {!seo?.twitter_card && (
          <meta name="twitter:card" content="summary_large_image" />
        )}
      </Helmet>

      <div className="arche-main">
          <div className="container-fluid">
            <div className="row arche-main-flu-row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 arche-bg-col">
                <div className="arche-side-img">
                  <img
                    src={`${IMG_URL}/d0/${dimensionData?.detailimage}`}
                    alt={dimensionData?.alt_text_img}
                  />
                </div>
                <div className="arche-bgDiv">
                  <div className="arche-text">
                    <h1>
                      {dimensionData?.name} {""}
                       <span>
                        {`${dimensionData?.dimension_letter ?? ""}${
                          clusterData?.cluster_letter ?? ""
                        }`
                          .split("")
                          .join(" ")}
                      </span>
                    </h1>
                    <p>{dimensionData?.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
    

        <div className="container">
          <div className="row arche-main-row-cont">
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 arche-side-main arche-side-main-767hde">
              {resultDetails &&
                resultDetails.length > 0 &&
                resultDetails.filter(
                  (item) => item.title !== "" && item.title !== null
                ).length > 0 && (
                  <SideResult
                    ref={sideResultRef}
                    onMenuItemClick={handleFocus}
                    resultDetails={resultDetails}
                    sideclass={sideclass}
                  />
                )}

              <div className="arche-right-end">
                <div className="arche-right-box1">
                  <img src={`${IMG_URL}/d0/${dimensionData?.image}`} alt={dimensionData?.imagealt} />
                </div>

                {dimensionData?.arche_adver_inner_image && (
                  <div
                    className="arche-right-box4-adverts"

                  onClick={
                      token
                        ? (TestLink != "" && TestLink != null
                            ? () => handleNavigete(TestLink)
                            : () => handleSub(dimensionData.arche_adver_inner_link))
                        : () => LoginShowSub(dimensionData.arche_adver_inner_link)
                    }
                    
                  >
                    <img
                      src={`${IMG_URL}/d0/${dimensionData?.arche_adver_inner_image}`}
                      alt={dimensionData?.advertisment_64_alt}
                    />
                  </div>
                )}

                <div className="arche-right-box2">
                  
                  <span>
                    <img src={lock1} alt="" />
                  </span>

                  <div   ref={containerRef} className={`ache-aver-cont${hasImage ? ' has-image' : ''}`} dangerouslySetInnerHTML={{ __html:dimensionData?.arche_side_bar_content }}/>

                </div>

                <div className="arche-right-box3">

                  <div dangerouslySetInnerHTML={{ __html:SideBarContent?.test_detail_page_side_heading }}/>

                  <a href={`/test/${free_test_slug}`}>
                    <button>
                      {SideBarContent?.test_detail_page_button_label}
                      <span>
                        <FontAwesomeIcon className="icc" icon={faAngleRight} />
                      </span>
                    </button>
                  </a>

                {!token && (
                  <>
                    <p dangerouslySetInnerHTML={{ __html:SideBarContent?.test_detail_page_side_sub_heading }}/>

                      <button onClick={SignShow} className="login-link">
                          {SideBarContent?.test_detail_page_sub_head_button_label}
                        <span>
                          <FontAwesomeIcon className="icc" icon={faAngleRight} />
                        </span>
                      </button>
                  </>
                )}


                </div>
                
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-9 col-lg-9 arche-full-mid">
              <div className="menu-short">
                <span className="menu-toggleBar" onClick={handleToggle}>
                  <FontAwesomeIcon  className={`crs ${isOpen ? 'show' : 'hide'}`} icon={faXmark} />
                  <FontAwesomeIcon     className={`mnus ${isOpen ? 'hide' : 'show'}`} icon={faBars} />
                </span>

                <div
                  className={`common-sidebar1 ${isOpen ? "open" : ""}`}
                  ref={sidebarRef1}
                >
                  <div className={`lsit-item-component ${isOpen ? "open" : ""}`}>
                    {resultDetails &&
                      resultDetails.length > 0 &&
                      resultDetails.filter((item) => item.title).length > 0 && (
                        <SideResult
                          ref={sideResultRef}
                          onMenuItemClick={(...args) => {
                            handleFocus(...args);
                            setIsOpen(false);
                          }}
                          resultDetails={resultDetails}
                          sideclass={sideclass}
                        />
                      )}
                  </div>
                </div>
              </div>

              <div className="arche-full">
                <div
                  data-index="0"
                  ref={(el) => {
                    if (el && el.nodeType === Node.ELEMENT_NODE) {
                      contentRefs.current[0] = el;
                    }
                  }}
                  key={`content-${0 || 0}-${0}`}
                  dangerouslySetInnerHTML={{
                    __html: dimensionData?.coredescription,
                  }}
                />

                <div
                  className="arche-ul"
                  data-index="1"
                  ref={(el) => {
                    if (el && el.nodeType === Node.ELEMENT_NODE) {
                      contentRefs.current[1] = el;
                    }
                  }}
                  key={`content-${1 || 1}-${1}`}
                  dangerouslySetInnerHTML={{ __html: dimensionData?.keytraits }}
                />
                {/* </ul> */}
                {/* Strengths */}
                {/* <ul className="arche-ul" ref={strengthsRef}> */}
                <div
                  className="arche-ul"
                  data-index="2"
                  ref={(el) => {
                    if (el && el.nodeType === Node.ELEMENT_NODE) {
                      contentRefs.current[2] = el;
                    }
                  }}
                  key={`content-${2 || 2}-${2}`}
                  dangerouslySetInnerHTML={{
                    __html: dimensionData?.strengthdescription,
                  }}
                />
                {/* </ul> */}
                {/* Challenges */}
                {/* <ul className="arche-ul" ref={challengesRef}> */}
                <div
                  data-index="3"
                  ref={(el) => {
                    if (el && el.nodeType === Node.ELEMENT_NODE) {
                      contentRefs.current[3] = el;
                    }
                  }}
                  key={`content-${3 || 3}-${3}`}
                  dangerouslySetInnerHTML={{
                    __html: dimensionData?.PotentialChallengesdescription,
                  }}
                />

                <div
                  data-index="4"
                  ref={(el) => {
                    if (el && el.nodeType === Node.ELEMENT_NODE) {
                      contentRefs.current[4] = el;
                    }
                  }}
                  key={`content-${4 || 4}-${4}`}
                  dangerouslySetInnerHTML={{ __html: dimensionData?.nextcontent }}
                />
              </div>

              <div className="arche-right-end arche-right-bottom">
                <div className="arche-right-box1">
                  <img src={`${IMG_URL}/d0/${dimensionData?.image}`} alt="" />
                </div>

                {dimensionData?.arche_adver_inner_image && (
                  <div
                    className="arche-right-box4-adverts"

                    onClick={
                      token
                        ? (TestLink != "" && TestLink != null
                            ? () => handleNavigete(TestLink)
                            : () => handleSub(dimensionData.arche_adver_inner_link))
                        : () => LoginShowSub(dimensionData.arche_adver_inner_link)
                    }
                  >
                    <img
                      src={`${IMG_URL}/d0/${dimensionData?.arche_adver_inner_image}`}
                      alt=""
                    />
                  </div>
                )}

                <div className="arche-right-box2">
                  <span>
                    <img src={lock1} alt="" />
                  </span>

                  <div ref={containerRef} className={`ache-aver-cont${hasImage ? ' has-image' : ''}`}dangerouslySetInnerHTML={{ __html:dimensionData?.arche_side_bar_content }}/>
                  
                </div>

                <div className="arche-right-box3">

                  <span dangerouslySetInnerHTML={{ __html:SideBarContent?.test_detail_page_side_heading }}/>

                  <a href={`/test/${free_test_slug}`}>
                    <button>
                      {SideBarContent?.test_detail_page_button_label}
                      <span>
                        <FontAwesomeIcon className="icc" icon={faAngleRight} />
                      </span>
                    </button>
                  </a>

                  {!token && (
                    <>
                    <p dangerouslySetInnerHTML={{ __html:SideBarContent?.test_detail_page_side_sub_heading }}/>

                    <button onClick={SignShow} className="login-link">
                        {SideBarContent?.test_detail_page_sub_head_button_label}
                      <span>
                        <FontAwesomeIcon className="icc" icon={faAngleRight} />
                      </span>
                    </button>
                    </>
                  )}
                  
                </div>

              </div>
            </div>
          </div>
        </div>


          {ShowModal && (
                                    
                <div 
                    className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                    subscription?.data?.length == 1 ? "single-subscription" : ""
                    }`}
                  
                  >

                    <div className="newdashpop-inner">

                        <div className="newdashpop-container">

                            <button
                              className="newdashpop-close"
                              onClick={() => setShowModal(false)}
                              >
                              &times;
                          </button>

                          <div className="conent-pop">
                          
                            <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                          </div>

                        </div>

                    </div>

                </div>
            )}
            
      </div> 
    </>
  );
}

export default ArchetypeDetailPage;
